var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import qs from '../../core/qs';
import axios from '../axios';
// 根据请求path、参数，作为cache的key
var generateKey = function (config) {
    var url = config.url, method = config.method, data = config.data, params = config.params;
    var search = url && url.indexOf('?') > -1 ? url.slice(url.indexOf('?')) : '';
    var allParams;
    try {
        allParams = qs.stringify('post' === (method || '').toLowerCase()
            ? data
            : __assign(__assign({}, qs.parse(search)), params));
    }
    catch (e) {
        allParams = '';
    }
    return url + "-" + method + "-" + allParams;
};
var requestMap = Object.create(null); // {}
var pendingResolveMap = Object.create(null);
// 把缓存住的请求，全部resolve
var resolveCacheResponse = function (key, response) {
    while (pendingResolveMap[key] && pendingResolveMap[key].length) {
        pendingResolveMap[key].shift().resolve(response);
    }
    requestMap[key] = 0;
};
// 把缓存住的请求，全部reject
var rejectCacheError = function (key, error) {
    while (pendingResolveMap[key] && pendingResolveMap[key].length) {
        pendingResolveMap[key].shift().reject(error);
    }
    requestMap[key] = 0;
};
export default (function () {
    return {
        requestMap: requestMap,
        pendingResolveMap: pendingResolveMap,
        requestSuccessInterceptor: function (config) {
            var debounceConfig = config.debounceConfig || {};
            var time = debounceConfig.time;
            var contentType = config.headers && config.headers['Content-Type'];
            if (time > 0 && contentType && contentType.indexOf && contentType.indexOf('application/json') > -1) {
                config.cancelToken = new axios.CancelToken(function (cancel) {
                    // 根据请求参数,生成cache key
                    var key = generateKey(config);
                    // 给config添加_cacheKey是因为response中的config的data会被stringify
                    config._cacheKey = key;
                    var now = Date.now();
                    if (!requestMap[key]) {
                        requestMap[key] = now;
                    }
                    else {
                        cancel(key);
                    }
                });
            }
            return config;
        },
        responseSuccessInterceptor: function (response) {
            // Any status code that lie within the range of 2xx cause this function to trigger
            // Do something with response data
            var config = (response || {}).config;
            var debounceConfig = (config || {}).debounceConfig;
            var debounceTime = (debounceConfig || {}).time;
            var now = Date.now();
            var cacheKey = config._cacheKey || '';
            if (cacheKey) {
                setTimeout(function () {
                    resolveCacheResponse(cacheKey, response);
                }, Math.max(requestMap[cacheKey] + debounceTime - now, 0));
                resolveCacheResponse(cacheKey, response);
            }
            return response;
        },
        responseErrorInterceptor: function (error) {
            // Any status codes that falls outside the range of 2xx cause this function to trigger
            // Do something with response error
            var key = error.message;
            var response = error.response || {};
            var config = response.config || {};
            var debounceConfig = config.debounceConfig || {};
            var debug = debounceConfig.debug;
            var cacheKey = config._cacheKey;
            if (axios.isCancel(error) && requestMap[key]) {
                debug && console.error(error);
                if (!pendingResolveMap[key]) {
                    pendingResolveMap[key] = [];
                }
                return new Promise(function (resolve, reject) {
                    pendingResolveMap[key].push({
                        resolve: resolve,
                        reject: reject
                    });
                });
            }
            cacheKey && rejectCacheError(cacheKey, error);
            return Promise.reject(error);
        },
    };
});
//# sourceMappingURL=index.js.map